"use client";

import React, { Suspense } from "react";
import { GraphCanvas } from "@/components/graph/canvas";
import { GraphToolbar } from "@/components/graph/toolbar/graph-toolbar";
import { ElementPanel } from "@/components/library/element-panel";
import { ContextSidebar } from "@/components/inspector/context-sidebar";

export default function ExplorePage() {
  return (
    <div className="h-full w-full absolute inset-0 overflow-hidden flex bg-background animate-fade-in">
      {/* Left Element Library Panel */}
      <ElementPanel />

      {/* Main Canvas Viewport Area */}
      <div className="flex-1 h-full relative overflow-hidden">
        <Suspense
          fallback={
            <div className="absolute inset-0 bg-background/50 backdrop-blur-xs flex items-center justify-center z-50">
              <div className="text-sm font-medium text-text-secondary animate-pulse">
                Caricamento del Grafo...
              </div>
            </div>
          }
        >
          <GraphCanvas />
        </Suspense>
        <GraphToolbar />
      </div>

      {/* Right Details Context Sidebar Panel */}
      <ContextSidebar />
    </div>
  );
}
